<template>
  <pt-fast-loan-audit class="pt-fast-loan-audit__withData" :allCitys="allCitys" @flashBorrowCompleted="flashBorrowCompleted" ref="table" @flashBorrowExport="flashBorrowExport"></pt-fast-loan-audit>
</template>

<script>
import PtFastLoanAudit from './index'
export default {
  name: 'pt-fast-loan-audit__withData',
  components: {
    'pt-fast-loan-audit': PtFastLoanAudit
  },
  data () {
    return {
      allCitys: []
    }
  },
  computed: {
    page () {
      return this.$refs.table.page
    }
  },
  methods: {
    flashBorrowCompleted (row) {
      let data = {
        flashBorrowId: row.id
      }
      this.$store.dispatch('flashBorrowComponent', data).then(res => {
        this.$message.success('完成银行分期返惠成功')
        this.$refs.table.getTableData(this.page)
      }).catch(err => {
        this.$message.error(err || '完成银行分期返惠失败')
      })
    },
    flashBorrowExport (data) {
      this.$store.dispatch('flashBorrowExport', data).then(res => {
        this.$message.success('数据准备中，完成导出后我们会将数据保存在“导出历史”中，您稍后下载即可')
      }).catch(err => {
        this.$message.error(err || '银行分期返惠导出失败')
      })
    },
    getAllCity () {
      this.$store.dispatch('getAllCity').then(res => {
        this.allCitys = res
      }).catch(err => {
        this.$message.error(err || '获取地区列表失败')
      })
    }
  },
  created () {
    this.getAllCity()
  }
}
</script>
